export default __webpack_public_path__ + "static/media/icon-upload.15a9828f.svg";